import React from 'react';
import './Sections.scss';
import Hyperlink from '../Hyperlink/Hyperlink';
import Statistics1 from '../Statistics/Statistics1';

function Section1() {
  const hyperlinkData = [
    {
      href: 'https://www.nar.realtor/newsroom/nar-finds-share-of-first-time-home-buyers-smaller-older-than-ever-before',
      copy: 'Recent data from the National Association of Realtors®',
      label: 'Visit Highlights From the Profile of Home Buyers and Sellers'
    },
    {
      href: 'https://www.nar.realtor/jessica-lautz',
      copy: 'Dr. Jessica Lautz, Deputy Chief Economist and Vice President of Research at NAR',
      label: 'Visit Highlights From the Profile of Home Buyers and Sellers'
    }
  ];

  return (
    <section className="sections sections-section1">
      <p className="sections-copy">
        2022 will go down in the record books as a historically challenging year for aspiring U.S.
        homebuyers. Galloping inflation eroded the value of nest eggs. Trying to rein in that
        inflation, the Federal Reserve raised its benchmark interest rate, leading to a spike in
        mortgage interest rates, which doubled from about 3.4% at the start of 2022 to over 7% by
        late October. Housing prices, which rose rapidly in many markets over the past few years,
        generally stayed elevated as supply remained constrained.
      </p>
      <p className="sections-copy sections-copy--margin">
        These challenges seem to have hit prospective first-time homebuyers particularly hard.{' '}
        <Hyperlink hyperlinkData={hyperlinkData[0]} /> (NAR) shows that first-time buyers made up
        only 26% of all buyers in 2022 – that’s the lowest percentage on record since NAR began
        tracking these percentages in 1981.
      </p>
      <Statistics1 />
      <p className="sections-copy">
        That means repeat buyers – those who had previously owned a home – represented nearly
        three-quarters of all buyers last year. According to{' '}
        <Hyperlink hyperlinkData={hyperlinkData[1]} />, repeat buyers tended to have an advantage
        thanks to the equity they had built through homeownership.
      </p>
      <p className="sections-copy">
        “One of the big takeaways is that the amount of housing wealth that can be built over time
        is pretty staggering,” says Lautz. “We found that homeowners who had owned a home for the
        last decade typically had $210,000 in equity from price gains before they made their next
        move. This shows that the journey into home ownership can be difficult, but it’s often worth
        it once you get there.”
      </p>
    </section>
  );
}

export default Section1;
